<template>
    <div id="navigation-mobile">
    <ul @click="$emit('toggleNav')" class="nav-ul-mobile">
        <li><a href="/#features" @click="goSection($event, 'features')">Features</a></li>
        <li><a href="/#demo" @click="goSection($event, 'demo')">Demo</a></li>
        <li><a href="/#panels" @click="goSection($event, 'panels')">Panels</a></li>
        <!-- <li><a href="/#creators">Creators</a></li> -->
        <li><a href="/#pricing" @click="goSection($event, 'pricing')">Pricing</a></li>
        <li><a href="/#news" @click="goSection($event, 'news')">News</a></li>
        <li><a href="/#faq" @click="goSection($event, 'faq')">FAQ</a></li>
        <li><a href="/login" target="_top">Log in</a></li>
        </ul>
    </div>
</template>

<script>
export default {
  methods: {
    goSection (e, id) {
      e.preventDefault()
      const el = this.$route.path === '/' ? document.getElementById(id) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      } else {
        this.$router.push({ path: '/', hash: '#' + id }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;700&display=swap');

  $base-font-size-px: 16px;
  $base-font-size-em: 1em;
  $base-font-family: 'Roboto',
  sans-serif;
  $base-line-height: 1.2em;

  #navigation-mobile {
    z-index: -1;
    position: absolute;
    top: 10px;
    right: 0;
    height: 100vh;
    overflow: hidden;
  }
  .nav-ul-mobile {
    width: 200px;
    padding-left: 100px;
    position: relative;
    top: 30px;
    right: 0;
  }
  .nav-ul-mobile li a {
    display: block;
    color: black;
    padding: 20px 10px 10px;
    font-family: $base-font-family;
    font-size:$base-font-size-em * 1;
    font-weight: 400;
    letter-spacing: 1.55px
  }

</style>
